module.exports = __webpack_public_path__ + "img/图像19.e3708db8.png";